import React, {useState} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import styles from './App.module.scss';
import classNames from 'classnames';
import {
  Footer,
  Workspace,
  MenuSidebar,
  QueueSidebar,
  OnboardingPage,
  HomePage,
  SettingsPage,
  UpdateAccountPage,
  LoginPage,
  SearchPage,
  LogoutPage,
  LibraryPage,
  CreateAccount,
} from './components';
import {
  AlbumViewPage,
  PlaylistViewPage,
} from './components/Pages/Library/Pages';

export function App() {
  const [devFlags, setDevFlags] = useState<string[]>([]);
  const [fullSizeQueueSidebar, setFullSizeQueueSidebar] = useState<
    boolean | null
  >(null);

  const renderLoggedInApp = true; // for demo

  const renderSettingsPage = () => (
    <SettingsPage {...{devFlags, setDevFlags}} />
  );

  const loggedInPages = (
    <Switch>
      <Route exact path="/home" component={HomePage} />
      <Route exact path="/settings" component={renderSettingsPage} />
      <Route exact path="/update_account" component={UpdateAccountPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route path="/search/:term" component={SearchPage} />
      <Route exact path="/logout" component={LogoutPage} />
      <Route path="/library" component={LibraryPage} />
      <Route
        path={`/catalog/album/:id`}
        component={() => <AlbumViewPage catalog />}
      />
      <Route
        path={`/catalog/playlist/:id`}
        component={() => <PlaylistViewPage catalog />}
      />
      <Route path="/*">
        <Redirect to="/home" />
      </Route>
    </Switch>
  );

  const onboardingPages = (
    <Switch>
      <Route exact path="/onboarding" component={OnboardingPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/create_account" component={CreateAccount} />
      <Route path="/*">
        <Redirect to="/onboarding" />
      </Route>
    </Switch>
  );

  // Combine default App class with styles.<flag> for each active dev flag
  const appWrapperClassName = classNames.apply(null, [
    styles.AppFrame,
    ...devFlags.map((flag) => styles[flag]),
  ]);

  const loggedInMarkup = (
    <div className={appWrapperClassName}>
      <div className={styles.TitleBar} />
      <div className={styles.Main}>
        <MenuSidebar />
        <Workspace pageMarkup={loggedInPages} />
        <QueueSidebar {...{fullSizeQueueSidebar, setFullSizeQueueSidebar}} />
      </div>
      <Footer />
    </div>
  );

  return renderLoggedInApp ? loggedInMarkup : onboardingPages;
}
